module.exports = __webpack_public_path__ + "img/ranking_03.a6ff33b7.png";